module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-500.woff2?eb89003999cea37e721a490d2d056e8d";